import React from 'react';
import { AiOutlineClockCircle } from 'react-icons/ai';
import { parseTime } from '../../utils/timeUtils';
import * as Style from './style';
import TimerPainel from './TimerPainel';

function Timer({
  currentTime,
  setTimer,
  startTimer,
  stopTimer,
  resetTimer,
  togglePainel,
  readOnly,
  timerButtonRef,
  timerPainelRef,
  toggleAux,
  isPainelActive,
  isTimerActive,
}) {
  const { friendlyTimeFormat } = parseTime(currentTime);

  return (
    <section style={{ position: 'relative', minWidth: '200px' }}>
      {currentTime <= 0 && readOnly ? null : (
        <Style.TimeButton
          ref={timerButtonRef}
          readOnly={readOnly}
          noBackground
          type="button"
          onClick={togglePainel}
        >
          {friendlyTimeFormat !== '' ? (
            <span>{`${friendlyTimeFormat} `}</span>
          ) : null}
          <AiOutlineClockCircle />
        </Style.TimeButton>
      )}
      {isPainelActive ? (
        <TimerPainel
          currentTime={currentTime}
          isTimerActive={isTimerActive}
          setTimer={setTimer}
          startTimer={startTimer}
          resetTimer={resetTimer}
          stopTimer={stopTimer}
          toggleAux={toggleAux}
          togglePainel={togglePainel}
          timerButtonRef={timerButtonRef}
          timerPainelRef={timerPainelRef}
        />
      ) : (
        ''
      )}
    </section>
  );
}

export default Timer;
